import React from 'react'
import Container from '../components/Container'
import SEO from '../components/SEO'
import Hero from '../components/Hero'
import PageBody from '../components/PageBody'

const Index = ({ data }) => {
  const page = data.page.edges[0]
  const topContent = page.node.topContent
  const title = page.node.heading
  const bottomContent = page.node.bottomContent
  const heroImage = page.node.image
  return (
    <div>
      <SEO />
      <Hero title={title} image={heroImage} height={'40vh'} />
      <Container>
        <PageBody body={topContent} />
        <PageBody body={bottomContent} />
      </Container>
    </div>
  )
}

export const query = graphql`
  query GetIndex {
    page: allContentfulHome {
      edges {
        node {
          image {
            title
            sizes(maxWidth: 1800) {
              ...GatsbyContentfulSizes_withWebp_noBase64
            }
            ogimg: resize(width: 1800) {
              src
              width
              height
            }
          }
          insurance
          heading
          topContent {
            childMarkdownRemark {
              html
            }
          }
          bottomContent {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js